module.exports = __webpack_public_path__ + "img/dummyUploadImage.dc45b32c.svg";